import { ToggleGroup, View } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import ApprovedOutcomeToggle from "./ApprovedOutcomeToggle";

const CLOArchiveToggle = ({ offering, archivedClos }) => {
  const { t } = useTranslation();

  return (
    <ToggleGroup
      toggleLabel={t("learningOutcomes.archive.archivedCLOs")}
      summary={t("learningOutcomes.archive.archivedCLOs")}
      size="small"
    >
      <View display="block" padding="small">
        {archivedClos.map((outcome) => (
          <ApprovedOutcomeToggle
            key={outcome.id}
            outcome={outcome}
            offering={offering}
            archived
          />
        ))}
      </View>
    </ToggleGroup>
  );
};

export default CLOArchiveToggle;
